// src/index.js
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { HelmetProvider } from 'react-helmet-async';

// Grab the root DOM node
const container = document.getElementById('root');

// Wrap your app in the same providers either way
const WrappedApp = (
  <HelmetProvider>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </HelmetProvider>
);

if (container.hasChildNodes()) {
  // If react-snap has already injected static HTML → hydrate
  hydrateRoot(container, WrappedApp);
} else {
  // Otherwise do a normal CSR mount
  createRoot(container).render(WrappedApp);
}
